import { render, staticRenderFns, recyclableRender, components } from "./z-paging.vue?vue&type=template&id=0f887f1e&scoped=true&name=z-paging&filter-modules=eyJwYWdpbmdXeHMiOnsidHlwZSI6InNjcmlwdCIsImNvbnRlbnQiOiIiLCJzdGFydCI6MTYxNTEsImF0dHJzIjp7InNyYyI6Ii4vd3hzL3otcGFnaW5nLXd4cy53eHMiLCJtb2R1bGUiOiJwYWdpbmdXeHMiLCJsYW5nIjoid3hzIn0sImVuZCI6MTYxNTF9LCJwYWdpbmdSZW5kZXJqcyI6eyJ0eXBlIjoicmVuZGVyanMiLCJjb250ZW50IjoiIiwic3RhcnQiOjE2MjI3LCJhdHRycyI6eyJtb2R1bGUiOiJwYWdpbmdSZW5kZXJqcyIsImxhbmciOiJqcyJ9LCJlbmQiOjI4MDYxfX0%3D&"
var renderjs
import script from "./js/z-paging-main.js?vue&type=script&lang=js&"
export * from "./js/z-paging-main.js?vue&type=script&lang=js&"
import style0 from "./z-paging.vue?vue&type=style&index=0&id=0f887f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f887f1e",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./wxs/z-paging-wxs.wxs?vue&type=custom&index=0&blockType=script&issuerPath=%2FUsers%2Fmac%2FDesktop%2FUceEduFront%2Funi_modules%2Fz-paging%2Fcomponents%2Fz-paging%2Fz-paging.vue&module=pagingWxs&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "uni_modules/z-paging/components/z-paging/z-paging.vue"
export default component.exports